document.addEventListener('DOMContentLoaded',()=>{
const hero=document.querySelector('[data-b-hero]');
if(hero){
 const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
 const connection=navigator.connection;
 const control=document.querySelector('[data-c-playback]');
 const sync=()=>{if(control)control.textContent=hero.paused?control.dataset.play:control.dataset.pause;};
 if(control){control.hidden=false;control.addEventListener('click',()=>{if(hero.paused)hero.play().catch(sync);else hero.pause();});hero.addEventListener('play',sync);hero.addEventListener('pause',sync);sync();}
 if(!motion.matches&&!(connection&&connection.saveData))hero.play().catch(sync);
 motion.addEventListener('change',()=>{if(motion.matches)hero.pause();});
 if(connection&&connection.addEventListener)connection.addEventListener('change',()=>{if(connection.saveData)hero.pause();});
 document.addEventListener('visibilitychange',()=>{if(document.hidden)hero.pause();});
}
document.querySelectorAll('.b-video video,[data-b-hero]').forEach(video=>{
 if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting)video.pause();});});observer.observe(video);}
});
});

document.addEventListener('DOMContentLoaded',()=>{
 const panel=document.querySelector('.slide-nav__overflow--top');
 const buttons=[...document.querySelectorAll('.js-toggle-slide-nav[aria-controls="SlideNav"]')];
 if(!panel)return;
 let wasOpen=false;
 const sync=()=>{const open=panel.classList.contains('js-menu--is-open');buttons.forEach(button=>button.setAttribute('aria-expanded',String(open)));if(open&&!wasOpen)panel.querySelector('a')?.focus();wasOpen=open;};
 new MutationObserver(sync).observe(panel,{attributes:true,attributeFilter:['class']});sync();
 document.addEventListener('keydown',event=>{if(event.key==='Escape'&&panel.classList.contains('js-menu--is-open')){const button=buttons.find(b=>b.getClientRects().length);if(button){button.click();button.focus();}}});
});
